import {Component, Input, OnInit} from '@angular/core';
import {TrailerIntervention} from 'shared';
import {TimePieChartEntry} from '../../reports/charts/time-pie-chart/time-pie-chart.component';

@Component({
  selector: 'app-fields-interventions-metrics',
  templateUrl: './fields-interventions-metrics.component.html',
  styleUrls: ['./fields-interventions-metrics.component.scss']
})
export class FieldsInterventionsMetricsComponent implements OnInit {

  @Input()
  intervention: TrailerIntervention;
  timeReport: TimePieChartEntry[];

  constructor() {
  }

  ngOnInit(): void {
    this.timeReport = [
      {name: 'Travail', duration: this.intervention.drive_working_duration || 0},
      {name: 'Arrêt', duration: this.intervention.stop_working_duration || 0},
      {name: 'Trajet', duration: this.intervention.total_road_duration || 0},
    ];
  }

}
